export default "__VITE_ASSET__579e25d3__"